import {
  buildUrlFromBase,
  eolsBaseApi,
  withApiErrorLoggingOnly
} from '../../utilities/api.utilities';
import {
  AppLinkData,
} from './eols-app-link.dtos';
import {
  Application,
} from './eols-app-link.constants';
import {
  AppLinkOutConfig,
  AppLinkOutResponse
} from './eols-app-link.models';
import { addSearchParams } from '../../utilities/app.utilities';
import { emptyObject } from '../../models/els.models';

export const getAppLinkApiUrl = (config: AppLinkOutConfig): string => {
  const { app, action } = config;
  if (app === Application.EPM_SKILL) {
    return `/api/sherpath/course-management/skill/app-link/${action}`;
  }
  const queryParams = {
    linkId: config.linkId,
    includeLinkHash: config.includeLinkHash,
    isCrossDomain: config.isCrossDomain,
    altSrcApp: config.altSrcApp,
    parentLinkId: config.parentLinkId
  };
  return addSearchParams(`/api/app-link/out/${app}/${action}`, queryParams);
};

export const getExternalAppRedirectUrl = (
  config: AppLinkOutConfig,
  token?: string
): Promise<AppLinkOutResponse> => {

  const headers = token ? {
    Authorization: `Bearer ${token}`
  } : emptyObject;

  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.post<AppLinkOutResponse>(
      buildUrlFromBase(getAppLinkApiUrl(config)),
      {
        ignoreToken: !!token,
        data: config.body
      },
      headers
    );
  });
};

export const getReturnAppLink = (props: {
    linkId: string;
    returnPostBody: unknown;
  }): Promise<AppLinkOutResponse> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.post<AppLinkOutResponse>(
      buildUrlFromBase(`/api/app-link/return/${props.linkId}`),
      props.returnPostBody ? { data: props.returnPostBody } : null
    );
  });
};

export type HashLinkDto = {
  token: string;
  linkId: string;
}

export const fetchHashLink = (hashLink: string): Promise<HashLinkDto> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.get<HashLinkDto>(buildUrlFromBase(`/api/app-link/hash-link/${hashLink}`), {
      headers: {
        'X-App-ID': Application.NHE_AI
      }
    });
  });
};

export const fetchAppLinkData = (key: string): Promise<AppLinkData> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.get<AppLinkData>(buildUrlFromBase(`/api/app-link/data/${key}`));
  });
};
